<template>
	<!-- BEGIN: Top Bar -->
	<div class="top-bar" v-if="currentRoute && currentRoute.name !== 'login'">
		<!-- BEGIN: Breadcrumb -->
		<div v-if="currentRoute && currentRoute.meta" class="-intro-x breadcrumb mr-auto hidden sm:flex">
			<a href class>Aplicación</a>
			<ChevronRightIcon class="breadcrumb__icon" />
			<span v-for="prev in prevs" class="flex items-center">
				<button @click="linkTo(prev.name)" class="breadcrumb--active">{{prev.meta.name}}</button>
				<ChevronRightIcon class="breadcrumb__icon" />
			</span>
			<a href class="breadcrumb--active">{{currentRoute.meta.name}}</a>
		</div>
		<!-- END: Breadcrumb -->
		
		<!-- BEGIN: Search -->
		<div v-if="$d().admin && currentRoute && currentRoute.name == 'side-menu-tablon'" class="intro-x relative mr-3 sm:mr-6">
			<button @click="newTablon" class="ml-auto dropdown-toggle cursor-pointer button text-white bg-theme-1 shadow-md flex items-center"> 
				<PlusIcon class="mr-2"/>
				Crear anuncio
			</button>
		</div>
		<!-- END: Search -->
		
		<!-- BEGIN: EmpresasYCentros -->
		<div v-if="$d().admin && currentRoute && showFilter(currentRoute)" class="intro-x relative mr-3 sm:mr-6">
			<select v-model="search_centro" @change="filtrarCentro()" v-if="$d().user && $d().user.centros" class="py-2 px-4 rounded">
				<option value="">Filtrar por centro</option>
				<option v-for="centro in $d().user.centros" :value="centro.num">{{centro.nombre_del_centro}}</option>
			</select>
		</div>
		<div v-if="$d().admin && currentRoute && showFilter(currentRoute)" class="intro-x relative mr-3 sm:mr-6">
			<select v-model="search_empresa" @change="filtrarEmpresa()" v-if="$d().user && $d().user.empresas" class="py-2 px-4 rounded">
				<option value="">Filtrar por empresa</option>
				<option v-for="empresa in $d().user.empresas" :value="empresa.num">{{empresa.nombre_de_la_empresa}}</option>
			</select>
		</div>
		<div v-if="$d().admin && currentRoute && showFilter(currentRoute)" class="intro-x relative mr-3 sm:mr-6">
			<button @click="newEmpresa" class="ml-auto dropdown-toggle cursor-pointer button text-white bg-theme-1 shadow-md flex items-center"> 
				<PlusIcon class="mr-2"/>
				Crear empresa
			</button>
		</div>
		<!-- END: EmpresasYCentros -->
		
		<!-- BEGIN: Search -->
		<div v-if="currentRoute && currentRoute.name == 'side-menu-tablon'" class="intro-x relative mr-3 sm:mr-6">
			<div class="search ">
				<input type="text" v-model="searchTerm" class="search__input input placeholder-theme-13" placeholder="Buscar..." />
				<SearchIcon class="search__icon dark:text-gray-300" />
			</div>
		</div>
		<!-- END: Search -->
		
		<!-- BEGIN: Resumen -->
		<div v-if="currentRoute && (currentRoute.name == 'side-menu-resumen' || currentRoute.name == 'side-menu-empresa-resumen')" class="intro-x relative mr-3 sm:mr-6">
			<a href="/ver-resumen/" target="_blank" class="ml-auto dropdown-toggle cursor-pointer button text-white bg-theme-11 rounded-full shadow-md flex items-center"> 
				<DownloadIcon class="mr-2"/>
				Exportar resumen
			</a>
		</div>
		<!-- END: Search -->
		
		<!-- BEGIN: Account Menu -->
		<div class="intro-x dropdown w-8 h-8 relative">
			<div class="dropdown-toggle w-8 h-8 flex bg-transparent border border-theme-1 text-theme-1 items-center justify-center rounded-full overflow-hidden shadow-lg image-fit zoom-in">
				<UserIcon class="search__icon dark:text-gray-300" />
			</div>
			<div class="dropdown-box w-56">
				<div class="dropdown-box__content box bg-theme-38 dark:bg-dark-6 text-white">
					<div class="p-4 border-b border-theme-40 dark:border-dark-3">
						<div v-if="$d().user && $d().user.nombre_que_mostrar" class="font-medium">{{ $d().user.nombre_que_mostrar }}</div>
						<div v-if="$d().user && $d().user.nombre_de_la_empresa" class="font-medium">{{ $d().user.nombre_de_la_empresa }}</div>
						<div v-if="$d().user.centro" class="text-xs text-theme-41 dark:text-gray-600">
							{{ $d().user.centro.nombre_del_centro }}
						</div>
					</div>
					<div class="p-2 border-t border-theme-40 dark:border-dark-3">
						<button @click="logout" class="w-full flex items-center block p-2 transition duration-300 ease-in-out hover:bg-theme-1 dark:hover:bg-dark-3 rounded-md">
							<ToggleRightIcon class="w-4 h-4 mr-2" />
							Salir
						</button>
					</div>
				</div>
			</div>
		</div>

		<!-- END: Account Menu -->
	</div>
	<!-- END: Top Bar -->
</template>

<script>
	import Vue from "vue";
	export default {
		data() {
			return {
				searchDropdown: false,
				search_centro: "",
				search_empresa: "",
				currentRoute:null,
				searchTerm:"",
				prevs:[],
				hideFilter: false
			};
		},
		mounted(){
			this.update(this.$router.currentRoute);
			this.$router.afterEach((to, from) => {
				this.update(to);
			})
	        window.bus.$on("hideFilter", (hide) => {
	            this.hideFilter = hide;
	        });
		},
		watch:{
			searchTerm:function(newVal,oldVal){
				this.searchTablon();
			}
		},
		methods: {
			showFilter(currentRoute) {
				let show = false;
				if(currentRoute.name === 'side-menu-empresas-y-centros') show = true;
				if(currentRoute.name === 'side-menu-empresa-resumen') show = true;
				if(currentRoute.name === 'side-menu-ultimos-docs') show = true;
				if(currentRoute.name === 'side-menu-control-docs') show = true;
				if(this.hideFilter) show = false;
				return show;
			},
			logout() {
				CmsApi.hook("/hooks/login/",{action: 'logout'}, (data) => {
					Vue.cookie.set("token", null);
					// Este click es un hack para que se cierre el dropbox
					document.querySelector('body').click()
					this.$router.push('login');
				});
			},
			linkTo(pageName) {
				this.$router.push({
					name: pageName
				});
			},
			update(to){
				this.prevs = [];
				if (this.$router.options.routes[0] && this.$router.options.routes[0].children && to.meta && to.meta.prevs) {
					for (const prev of to.meta.prevs){
						var exists = this.$router.options.routes[0].children.find(rec => rec.name === prev);
						if (exists){
							this.prevs.push(exists);
						}
					}
				}
				this.currentRoute = to;
			},
			showSearchDropdown() {
				this.searchDropdown = true;
			},
			hideSearchDropdown() {
				this.searchDropdown = false;
			},
			newTablon(){
				window.bus.$emit("tablon-create");
			},
			newEmpresa(){
	            CmsApi.hook("/hooks/login/",{empresa: 'crear'}, (data) => {
	                if (data.success) {
	                    window.bus.$emit("dataReloaded", data);
	                    this.$router.push('empresa');
	                }
	            });
			},
			searchTablon(){
				window.bus.$emit("tablon-search",{searchTerm:this.searchTerm})
			},
			filtrarCentro(){
				window.bus.$emit("filtrarCentro",{num:this.search_centro})
			},
			filtrarEmpresa(){
				window.bus.$emit("filtrarEmpresa",{num:this.search_empresa})
			}
		}
	};

</script>
